export default __webpack_public_path__ + "static/media/A.bd293011.jpeg";